/**
 * Stay in the Loop — newsletter popup (Mailchimp embed POST via hidden iframe).
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (!root || root.dataset.jnpReady === '1') return;
    root.dataset.jnpReady = '1';

    const form = root.querySelector('[data-jnp-form]');
    const success = root.querySelector('[data-jnp-success]');
    const dialog = root.querySelector('[data-jnp-dialog]');
    const storageKey = root.dataset.storageKey || 'jaromin_newsletter_popup_v1';
    const params = new URLSearchParams(window.location.search || '');
    const force = params.has('jnp') || params.get('newsletter') === '1';
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const configuredDelay = Math.max(0, Number(root.dataset.delaySeconds || 12) * 1000);
    // Theme editor: show quickly so Customize is testable. ?jnp=1: show immediately.
    const delayMs = force ? 0 : designMode ? 1000 : configuredDelay;
    const againDays = Math.max(1, Number(root.dataset.showAgainDays || 14));
    let lastFocus = null;

    function dismissed() {
      if (force || designMode) return false;
      try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) return false;
        const until = Number(raw);
        return Number.isFinite(until) && Date.now() < until;
      } catch {
        return false;
      }
    }

    function dismiss(days) {
      if (designMode) return;
      try {
        const ms = (days || againDays) * 24 * 60 * 60 * 1000;
        localStorage.setItem(storageKey, String(Date.now() + ms));
      } catch {
        /* private mode */
      }
    }

    function focusables() {
      const scope = dialog || root;
      return Array.prototype.filter.call(scope.querySelectorAll(FOCUSABLE), function (el) {
        if (el.closest('.jnp__iframe')) return false;
        const hidden = el.hidden || el.getAttribute('aria-hidden') === 'true';
        if (hidden) return false;
        return el.getClientRects().length > 0;
      });
    }

    function trapTab(e) {
      if (e.key !== 'Tab' || root.getAttribute('data-open') !== 'true') return;
      const list = focusables();
      if (!list.length) {
        e.preventDefault();
        return;
      }
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onDocumentKey(e) {
      if (root.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') {
        close(true);
        return;
      }
      trapTab(e);
    }

    function open() {
      lastFocus = document.activeElement;
      root.removeAttribute('hidden');
      root.hidden = false;
      root.setAttribute('data-open', 'true');
      document.documentElement.classList.add('jnp-open');
      document.addEventListener('keydown', onDocumentKey);
      const list = focusables();
      const target = root.querySelector('input[type="email"]') || list[0];
      if (target) target.focus({ preventScroll: true });
    }

    function close(persist) {
      root.removeAttribute('data-open');
      document.documentElement.classList.remove('jnp-open');
      document.removeEventListener('keydown', onDocumentKey);
      if (persist !== false) dismiss(againDays);
      window.setTimeout(function () {
        root.hidden = true;
        root.setAttribute('hidden', '');
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        }
      }, 220);
    }

    root.querySelectorAll('[data-jnp-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    if (form) {
      form.addEventListener('submit', function () {
        window.setTimeout(function () {
          if (form) form.hidden = true;
          if (success) {
            success.hidden = false;
            success.focus({ preventScroll: true });
          }
          dismiss(againDays * 6);
        }, 400);
      });
    }

    const path = window.location.pathname || '';
    if (
      path.indexOf('/checkouts') === 0 ||
      path.indexOf('/checkout') === 0 ||
      path.indexOf('/orders') === 0 ||
      path.indexOf('/password') === 0 ||
      path.indexOf('/pages/contact') === 0 ||
      path.indexOf('/pages/educators') === 0 ||
      path.indexOf('/pages/continue') === 0 ||
      path.indexOf('/pages/trailhead-dealer') === 0 ||
      dismissed()
    ) {
      root.hidden = true;
      root.setAttribute('hidden', '');
      return;
    }

    root.hidden = true;
    root.setAttribute('hidden', '');
    window.setTimeout(open, delayMs);
  }

  function boot() {
    document.querySelectorAll('[data-jaromin-newsletter-popup]').forEach(init);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
